module.exports = __webpack_public_path__ + "media/images/icon-bw-line@2x-f9decd54adcb604959f8f94a60190ce1.png";